export const CURRENCY = "₦";
